export default {
    getPasteActionInfoFromInMem(state) {
        return state.pasteActionsinfo;
    },
    getNewUpdatesPageData(state){
        return state.newUpdates;
    }
};